import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
export var useViewType = createStateHook(store, {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  selector: function selector(state) {
    return state.viewType;
  }
});